const NotFound = () => {
    return <h1>Uh, oh, there's nothing here :(</h1>;
};

export default NotFound;
